import { groupBy, flatMap } from 'lodash';

import { IItem } from '../../Items/types';
import { ISimpleItem, IGroup } from '../types';

export const prepareItemsAndGroups = (
  allItems: IItem[],
  allGroups: IGroup[]
) => {
  const itemsInGroups: ISimpleItem[] = [];
  const groups = allGroups.map(group => ({
    ...group,
    itemGroups: group.itemGroups.map((itemGroup, index) => {
      itemsInGroups.push(...itemGroup.items);
      return {
        ...itemGroup,
        id: `old-${group.parameter.id}-${index}`,
        isExpanded: true,
      };
    }),
  }));

  const items = groupBy(
    flatMap(allItems, ({ id, name, parameter }) => {
      if (itemsInGroups.find(item => item.id === id)) {
        return [];
      }
      return [
        {
          id,
          name,
          parameterId: parameter.id,
        },
      ];
    }),
    'parameterId'
  );

  return { groups, items };
};



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/services/prepareItemsAndGroups.ts